import React from "react";

const Attribution = () => {
  return (
    <div className="attribution">
      Challenge by{" "}
      <a
        href="https://www.frontendmentor.io?ref=challenge"
        target="_blank"
        rel="noreferrer"
      >
        Frontend Mentor
      </a>
      . Coded by{" "}
      <a
        href="https://github.com/Abdelghafour122"
        target="_blank"
        rel="noreferrer"
      >
        Abdelghafour122
      </a>
      .
    </div>
  );
};

export default Attribution;
